import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9h18v-6h-18v18h6v-18","key":"svg-0"}],["path",{"d":"M3 15h12v-12","key":"svg-1"}]]

/**
 * IconChartCohort
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hhcnQtY29ob3J0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDloMTh2LTZoLTE4djE4aDZ2LTE4IiAvPgogIDxwYXRoIGQ9Ik0zIDE1aDEydi0xMiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/chart-cohort
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChartCohort = createReactComponent('outline', 'chart-cohort', 'ChartCohort', __iconNode);

export default IconChartCohort;